// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc3621de","239":"9180e550","455":"5e743672","539":"854cfe7e","858":"e41ed8a1","934":"5318a5df"}[chunkId] + ".chunk.js";
};